var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultationCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8571 11.5H13.1428C10.8745 11.5 9.03564 13.3388 9.03564 15.6071V32.8571C9.03564 35.1255 10.8745 36.9643 13.1428 36.9643H32.8571C35.1254 36.9643 36.9642 35.1255 36.9642 32.8571V15.6071C36.9642 13.3388 35.1254 11.5 32.8571 11.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03564 18.0715H36.9642",
    stroke: "white",
    strokeWidth: 1.64286
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6069 9.03564V13.9642M30.3926 9.03564V13.9642",
    stroke: "currentColor",
    strokeWidth: 2.46429,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 32.8572C20.207 30.8858 18.0713 29.2429 18.0713 26.9429C18.0713 25.4643 19.2213 24.3965 20.6177 24.3965C21.5213 24.3965 22.4249 24.8072 22.9999 25.6286C23.5749 24.8072 24.4784 24.3965 25.382 24.3965C26.7784 24.3965 27.9284 25.4643 27.9284 26.9429C27.9284 29.2429 25.7927 30.8858 22.9999 32.8572Z",
    fill: "secondColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationCalendar);
export default __webpack_public_path__ + "static/media/consultation-calendar.468c32e8ee17f2470a712bee6a064dae.svg";
export { ForwardRef as ReactComponent };